// src/pages/ClientData/components/SearchHeader.js
import React from 'react';

const SearchHeader = ({
  clientCodeInput,
  processCodeInput,
  onClientCodeChange,
  onProcessCodeChange,
  nameSearchInput,
  onNameSearchChange,
  onSearchByName,
  nameSearching,
  nameSearchError,
  onSearch,
  searching,
  error,
  hasResults,
  onChatComIA,
  onSaveDocument,
  saving,
  loadAllMovements,
  onLoadAllMovementsChange,
  loadAllFiles,
  onLoadAllFilesChange
}) => {
  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      onSearch();
    }
  };

  const handleNameKeyDown = (e) => {
    if (e.key === 'Enter') {
      onSearchByName();
    }
  };

  return (
    <div className="cd-search-header">
      <div className="cd-search-fields cd-name-search">
        <div className="cd-search-field">
          <label className="field-label">
            <span>🔎</span>
            Pesquisa por Nome
          </label>
          <input
            type="text"
            value={nameSearchInput}
            onChange={(e) => onNameSearchChange(e.target.value)}
            onKeyDown={handleNameKeyDown}
            placeholder="Nome do cliente"
            className="name-input"
          />
        </div>

        <button
          className="search-btn"
          onClick={onSearchByName}
          disabled={nameSearching || searching}
        >
          {nameSearching ? '⌛ A pesquisar...' : '🔍 Pesquisar Nome'}
        </button>
      </div>

      {nameSearchError && <div className="error-message">{nameSearchError}</div>}

      <div className="cd-search-fields">
        <div className="cd-search-field">
          <label className="field-label">
            <span>🔢</span>
            Código do Cliente
          </label>
          <input
            type="text"
            value={clientCodeInput}
            onChange={(e) => onClientCodeChange(e.target.value)}
            onKeyDown={handleKeyDown}
            placeholder="00000"
            className="code-input"
            inputMode="numeric"
          />
        </div>

        <div className="cd-search-field">
          <label className="field-label">
            <span>📁</span>
            Código do Processo
          </label>
          <input
            type="text"
            value={processCodeInput}
            onChange={(e) => onProcessCodeChange(e.target.value)}
            onKeyDown={handleKeyDown}
            placeholder="00000.0000"
            className="code-input"
            inputMode="numeric"
          />
        </div>
      </div>

      <div className="cd-load-options">
        <label className="cd-checkbox">
          <input
            type="checkbox"
            checked={loadAllMovements || loadAllFiles}
            disabled={searching || loadAllFiles}
            onChange={(e) => onLoadAllMovementsChange(e.target.checked)}
          />
          <span>Carregar todos os movimentos</span>
        </label>
        <label className="cd-checkbox">
          <input
            type="checkbox"
            checked={loadAllFiles}
            disabled={searching}
            onChange={(e) => onLoadAllFilesChange(e.target.checked)}
          />
          <span>Carregar movimentos e ficheiros (contexto completo)</span>
        </label>
      </div>

      <div className="cd-search-controls">
        <p className="cd-search-hint">É obrigatório indicar o código do cliente ou o código do processo.</p>
        <button
          className="search-btn"
          onClick={onSearch}
          disabled={searching}
        >
          {searching ? '⌛ A pesquisar...' : '🔍 Pesquisar'}
        </button>
      </div>

      {error && <div className="error-message">{error}</div>}

      {hasResults && (
        <div className="cd-search-actions">
          <button className="action-btn chat-btn" onClick={onChatComIA}>
            💬 CHAT COM IA
          </button>
          <button className="action-btn save-btn" onClick={onSaveDocument} disabled={saving}>
            {saving ? '⌛ A guardar...' : '💾 SALVAR EM MEUS DOCUMENTOS'}
          </button>
        </div>
      )}
    </div>
  );
};

export default SearchHeader;
